import React, { useState, useEffect } from "react";
import API from "../../Service/Baseservice";
import { useNavigate } from "react-router-dom";


const NewsCategoryAdd = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        language_id: "",
        news_id: "",
        category_name: "",
        icon_image: "",
        description: "",
        createdBy: 1,
        updatedBy: 1,
    });
    const [selectedImage, setSelectedImage] = useState(null);
    const [isUploading, setIsUploading] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);
    const [popup, setPopup] = useState({ show: false, type: "", message: "" });
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };
    const toBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });

    useEffect(() => {
        if (!selectedImage) return;

        setIsUploading(true);

        toBase64(selectedImage)
            .then((base64) => {
                const uploadPayload = {
                    name: "Icon Image",
                    image: [
                        {
                            name: selectedImage.name,
                            type: selectedImage.type,
                            size: `${selectedImage.size} bytes`,
                            base64: base64,
                        },
                    ],
                };
                return API.post("imageUpload/add", uploadPayload);
            })
            .then((res) => {
                if (res.data && res.data.success && res.data.url) {
                    setFormData((prev) => ({ ...prev, icon_image: res.data.url }));
                } else {
                    throw new Error("Upload failed");
                }
            })
            .catch((err) => {
                console.error("Image upload failed:", err);
                setPopup({
                    show: true,
                    title: "Error",
                    message: "Image upload failed. Please try again.",
                    type: "error",
                });
            })
            .finally(() => setIsUploading(false));
    }, [selectedImage]);

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setSelectedImage(file);
            setPreviewImage(URL.createObjectURL(file));
        }
    };
    const handleSubmit = (e) => {
        e.preventDefault();

        if (!formData.icon_image || !formData.language_id || !formData.category_name || !formData.description) {
            setPopup({
                show: true,
                type: "info",
                message: "Please fill all required fields.",
            });
            return;
        }

        setIsSubmitting(true);
        API.post("add_newscategory/add", formData)
            .then((res) => {
                const success = res.data?.success;
                const categoryName = formData.category_name || "";
                const message = success
                    ? `${categoryName} Category added successfully!`
                    : (res.data?.message || "Failed to add category");

                setPopup({
                    show: true,
                    type: success ? "success" : "error",
                    message,
                });

                // if (success) {
                //     setTimeout(() => navigate("/newscategory"), 2000);
                // }
            })
            .catch((err) => {
                console.error("Add News Category Error:", err);
                setPopup({
                    show: true,
                    type: "error",
                    message: "Failed to add News Category. Please try again.",
                });
            })
            .finally(() => setIsSubmitting(false));
    };

    return (
        <div className="category-container1">
            {/* Header */}
            <div className="category-header1">
                <h2 className="category-title1">Add News Category</h2>
                <div className="header-buttons">
                    <button onClick={handleSubmit} className="btn saves-btn">
                        {isSubmitting ? "Save" : "Save"}
                    </button>
                    <button onClick={() => navigate("/newscategory")} className="cancel-btn ">
                        Back
                    </button>
                </div>
            </div>

            {/* Form */}
            <div className="category-form-card">
                <form>
                    <div className="image-upload-container">
                        <label htmlFor="icon_image" className="image-label">
                            {previewImage ? (
                                <img src={previewImage} alt="Preview" className="admin-image-preview" />
                            ) : (
                                <div className="image-placeholder">+</div>
                            )}
                        </label>
                        <input
                            type="file"
                            id="icon_image"
                            name="icon_image"
                            accept="image/*"
                            onChange={handleImageChange}
                            style={{ display: "none" }}
                        />
                        <p className="image-note">Click the circle to upload image</p>
                    </div>
                    <div className="cate-form-row">
                        <div className="cate-form-field">
                            <label>Language <span className="required">*</span></label>
                            <select
                                name="language_id"
                                value={formData.language_id}
                                onChange={handleChange}
                            >
                                <option value="">Select Language</option>
                                <option value="1">English</option>
                                <option value="2">Français</option>
                            </select>
                        </div>

                        <div className="cate-form-field">
                            <label>Category Name <span className="required">*</span></label>
                            <input
                                type="text"
                                name="category_name"
                                placeholder="Enter category name"
                                value={formData.category_name}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className="form-group1">
                        <label>Description <span className="required">*</span></label>
                        <textarea
                            name="description"
                            placeholder="Enter description"
                            value={formData.description}
                            onChange={handleChange}
                            rows="4"
                        />
                    </div>
                </form>
            </div>

            {/* Popup */}
            {popup.show && (
                <div className="popup-overlay">
                    <div className={`popup-box popup-${popup.type}`}>
                        <p>{popup.message}</p>
                        <div className="popup-buttons">
                           <button
                                className="btn ok-btn"
                                onClick={() => {
                                    setPopup({ ...popup, show: false });

                                    if (popup.type === "success") {
                                        navigate("/newscategory");
                                    }
                                }}
                            >
                                OK
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default NewsCategoryAdd;
